export type TagGender = 'Men' | 'Women' | 'Unisex' | null;

export function getProductGender(
  hasMaleTag: boolean,
  hasFemaleTag: boolean
): TagGender {
  if (hasMaleTag && hasFemaleTag) {
    return null; // Unisex
  }
  if (!hasMaleTag && !hasFemaleTag) {
    return null; // No gender
  }
  if (hasMaleTag) {
    return 'Men';
  }
  if (hasFemaleTag) {
    return 'Women';
  }
  return null;
}

export interface ProductDetail {
  bundleProducts?: Array<{ masterProductId: number } & Record<string, any>>;
  product?: Record<string, any>;
}

export function getCurrentProduct(
  productDetail: ProductDetail,
  masterProductId: number
): Record<string, any> {
  if (productDetail.bundleProducts?.length > 0) {
    return (
      productDetail.bundleProducts.find(
        (product) => product.masterProductId === masterProductId
      ) || {}
    );
  }
  return productDetail.product || {};
}

export function constructGenderUrl(
  url: string | undefined,
  filterByProductGender: boolean,
  tagGender: TagGender
): string | undefined {
  if (typeof url === 'undefined') {
    return undefined;
  }
  if (!filterByProductGender) {
    return url;
  }
  if (!tagGender) {
    return url;
  }
  const updatedUrl = new URL(url, window.location.origin);
  updatedUrl.searchParams.set('tag_gender_list', tagGender);
  return updatedUrl.pathname + updatedUrl.search;
}
